export class SopimusUriService {
  getPoistaKayttajienRoolitUri(asiakasAvain: string | number, tyoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/poista-kayttajien-rooleja/' + tyoAvain
  }

  getEmailPaattyyUri(asiakasAvain: string | number, tyoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/asiakkaan-sopimuksen-paatosemail-laheta-postmarkilla/' + tyoAvain
  }

  getLopetaMaksujenVastaanottoJaMaksaminenTyojonoUri(asiakasAvain: string, tyojonoAvain: string) {
    return 'tyojono/' + asiakasAvain + '/lopeta-maksujen-vastaanotto/' + tyojonoAvain
  }

  getPoistaRoolitSailytaTositteetAvain(sopimuskausiAvain: string): string {
    return sopimuskausiAvain + 'poista_roolit_sailyta_tositteet'
  }

  getPoistaRoolitJaDeaktivoiAvain(sopimuskausiAvain: string): string {
    return sopimuskausiAvain + 'poista_roolit_ja_deaktivoi'
  }

  getEmailPaattymassaAvain(sopimuskausiAvain: string): string {
    return sopimuskausiAvain + 'email_paattymassa'
  }

  getEmailPaattynytAvain(sopimuskausiAvain: string): string {
    return sopimuskausiAvain + 'email_paattynyt'
  }

  getLopetaApixMaksujenVastaanottoJaMaksaminenAvain(sopimuskausiAvain: string): string {
    return sopimuskausiAvain + 'lopeta-apix-maksujen-vastaanotto'
  }
}
